import { COURSE_TYPE } from '@oup/shared-node-browser/course.js';

const filterCoursesByType = courses => {
  const standardCourses = {};
  const readerBundles = {};
  const entries = Object.entries(courses);
  entries.forEach(([courseId, course]) => {
    const { title, properties } = course;
    if (title.toLowerCase().includes('reader') || properties?.shortTitle.toLowerCase().includes('reader')) {
      course.courseType = COURSE_TYPE.READER_BUNDLE;
      readerBundles[courseId] = course;
    } else {
      standardCourses[courseId] = course;
    }
  });

  return { standardCourses, readerBundles };
};

export default filterCoursesByType;
